module.exports = __webpack_public_path__ + "static/media/undefined_event.11763d0a.jpg";